"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
function makeCoefficient(decimalPlaces) {
    const one = new bignumber_js_1.default(1);
    const ten = new bignumber_js_1.default(10);
    return one.dividedBy(ten.exponentiatedBy(decimalPlaces));
}
class BaseCurrencyType {
    constructor(ticker, decimalPlaces) {
        this.ticker = ticker;
        this.decimalPlaces = new bignumber_js_1.default(decimalPlaces);
        this.coefficient = makeCoefficient(this.decimalPlaces);
    }
}
exports.default = BaseCurrencyType;
//# sourceMappingURL=BaseCurrencyType.js.map